//@flow
import React from "react";
import classNames from "classnames";

import "./HeaderSubSecao.css";

export function HeaderSubSecao({ className, ...props }: *) {
  return <div className={classNames("HeaderSubSecao", className)} {...props} />;
}

export function HeaderSubSecaoTitulo({ className, ...props }: *) {
  return (
    <div
      className={classNames("HeaderSubSecao__titulo", className)}
      {...props}
    />
  );
}

export function HeaderSubSecaoGrupo({ className, ...props }: *) {
  return (
    <div
      className={classNames("HeaderSubSecao__grupo", className)}
      {...props}
    />
  );
}
